module.exports = __webpack_public_path__ + "static/media/20.e4538b99.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/hairback/20.png
// module id = 658
// module chunks = 0